import {parseAxiosPromise} from '@/axiosInstance'
import {QUERY_KEYS} from '@/queryClient'
import {UseInfiniteQueryOptions, useQuery} from '@tanstack/react-query'
import {captureException} from '@sentry/react'
import {useInputSearch} from '@/hooks/useInputSearch'
import {z} from 'zod'
import {Role} from '@/features/users/types'
import {httpGetAccessProfiles} from '@/features/users/http/users.http'

export const ResponseShape = z.array(Role)
type ResponseShape = z.infer<typeof ResponseShape>

export const useGetAccessProfiles = (options?: Pick<UseInfiniteQueryOptions<ResponseShape>, 'staleTime'>) => {
    const {searchValue, onSearch, onResetSearch} = useInputSearch()

    const query = useQuery({
        queryKey: [QUERY_KEYS.ACCESS_PROFILES, searchValue],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpGetAccessProfiles({
                    search: searchValue,
                    responseType: 'extended'
                }),
                responseShape: ResponseShape,
                onZodError: captureException
            }),
        ...options
    })

    return {
        ...query,
        searchValue,
        onResetSearch,
        onSearch
    }
}
